// extracted by mini-css-extract-plugin
export default {"expo-menu":"expoAd_expo-menu__dsoqG","expo-title":"expoAd_expo-title__O+KV2","choosed":"expoAd_choosed__rTtls"};